import MuiAlert from "@mui/lab/Alert";
import { Button, Snackbar, TextField } from "@mui/material";
import { Component } from "react";
import swal from "sweetalert";

import UberEatActionCreator from "../../controller/action/UbereatsActionCreator";
import UberEatStore from "../../controller/store/UbereatsStore";

import type { CSSProperties } from "@mui/system/CSSProperties";
import uberEat_logo from "../../assets/images/uberEat_logo.png";
import UbereatsActionCreator from "../../controller/action/UbereatsActionCreator";
import { DeliveraStore } from "../../controller/model/delivera/DeliveraStore";
import Service from "../../controller/model/service/Service";
import LoadingComponent from "../utils/LoadingComponent";

interface StateInterface {
  service: Service;
  isReady: boolean;
  showError: boolean;
  message: string | undefined;
}

const _updateState = () => {
  const serviceUser = UberEatStore.service;
  return {
    service: serviceUser,
  };
};

class UbereatsContainer extends Component {
  public state: StateInterface;
  private locationId: string | undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      service: UberEatStore.service,
      isReady: false,
      showError: false,
      message: undefined,
    };
    this.locationId = undefined;
    this._handleStateChange = this._handleStateChange.bind(this);
    this._handleTapLloginButton = this._handleTapLloginButton.bind(this);
    this._handleLoginChange = this._handleLoginChange.bind(this);
    this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this);
  }

  componentDidMount() {
    UberEatStore.addChangeListener(this._handleStateChange);
    UberEatActionCreator.loadUberEatServiceUser()
      .then(() => {
        this.setState({ isReady: true });
      })
      .catch((err: any) => {
        console.warn(err);
        this.setState({
          isReady: true,
          showError: true,
          message: "Error lors de la récupération des infos ubereats",
        });
      });
  }

  componentWillUnmount() {
    UberEatStore.removeChangeListener(this._handleStateChange);
  }

  _handleStateChange() {
    this.setState(_updateState());
  }

  _handleTapLloginButton() {
    if (this.locationId !== undefined) {
      UberEatActionCreator.connectUberEatServiceUser(this.locationId).catch(
        (err) => {
          console.warn(err);
          this.setState({
            showError: true,
            message: "Erreur de connexion, veuillez vérifier le location Id",
          });
        }
      );
    }
  }

  _handleLoginChange(event: any) {
    this.locationId = event.target.value;
  }

  _handleTapDisconnectButton() {
    UberEatActionCreator.disconnectUbereatsService().catch((err: any) => {
      console.warn(err);
      this.setState({
        showError: true,
        message: "Erreur lors de la déconnexion, veuillez réessayer",
      });
    });
  }

  _handleCloseSnackBar() {
    this.setState({ showError: false, message: "" });
  }

  _handleClickOldCarte(aCarte: any) {
    const store = new DeliveraStore(aCarte, "ubereats");
    swal({
      title: "Envoyer la carte ?",
      text: `Êtes vous sur de vouloir envoyer cette ancienne carte à Uber eats`,
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    })
      .then((result) => {
        if (result === true) {
          UbereatsActionCreator.sendStoreToUbereastWithoutSave(
            store,
            this.state.service
          )
            .then(() => {
              alert("Carte renvoyer avec success");
              UbereatsActionCreator.fetchCurrentUbereatsStore(
                this.state.service
              );
            })
            .catch((err) => {
              console.warn(err);
              this.setState({
                showError: true,
                message:
                  "Erreur lors de l'envoie de la carte, veuillez réessayer",
              });
            });
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({
          showError: true,
          message: "Erreur lors de l'envoie de la carte, veuillez réessayer",
        });
      });
  }

  render() {
    return (
      <div style={rootStyle}>
        <Snackbar
          open={this.state.showError}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <MuiAlert severity="error" onClose={this._handleCloseSnackBar}>
            {this.state.message}
          </MuiAlert>
        </Snackbar>
        {true === this.state.isReady ? (
          false === this.state.service.actived ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                textAlign: "center",
              }}
            >
              <div style={{ marginTop: "60px", width: "100%" }}>
                <img
                  alt="ubereats"
                  src={uberEat_logo}
                  style={{ width: "400px", margin: "auto" }}
                />
                <div style={{ marginTop: "10px", padding: "20px" }}>
                  <div style={{ width: "50%", display: "inline-block" }}>
                    <TextField
                      InputProps={{ style: { fontSize: 22 } }}
                      InputLabelProps={{
                        style: {
                          color: "#474F5E",
                        },
                      }}
                      id="uid"
                      label="Login UID"
                      fullWidth={true}
                      onChange={this._handleLoginChange}
                      variant="outlined"
                    />

                    <div style={{ marginTop: "40px", textAlign: "right" }}>
                      <Button
                        variant="contained"
                        onClick={this._handleTapLloginButton}
                        style={{
                          color: "white",
                        }}
                        color="secondary"
                      >
                        Connexion
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div style={rootStyle}>
              <div
                className="deliveroo_image"
                style={{ marginTop: "60px", width: "100%" }}
              >
                <img
                  alt="ubereats"
                  src={uberEat_logo}
                  style={{ width: "400px" }}
                />

                <h3 style={{ color: "#474F5E", padding: "25px" }}>
                  Vous êtes actuellement connecté à Uber Eats avec
                  l'établissement {this.state.service.name}
                </h3>

                <Button
                  color="secondary"
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={this._handleTapDisconnectButton}
                >
                  Déconnexion
                </Button>
              </div>
              <div
                style={{
                  marginTop: "60px",
                  width: "100%",
                }}
              >
                <h4
                  style={{
                    textAlign: "center",
                    color: "#474F5E",
                    marginBottom: "10px",
                    fontSize: "17px",
                  }}
                >
                  Sauvegarde de carte :
                </h4>
                {Object.keys(this.state.service.last_updates).map((aKey, i) => {
                  const date = new Date(parseFloat(aKey));
                  const carte = (this.state.service.last_updates as any)[aKey];

                  return (
                    <div key={i} style={{ padding: "5px" }}>
                      <Button
                        color="primary"
                        onClick={() => this._handleClickOldCarte(carte)}
                      >{`carte envoyer le ${date.toISOString()}`}</Button>
                    </div>
                  );
                })}
              </div>
            </div>
          )
        ) : (
          <div>
            <LoadingComponent isOpen={this.state.isReady} />
          </div>
        )}
      </div>
    );
  }
}

const rootStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  textAlign: "center",
};

export default UbereatsContainer;
